export  default {
   SEGMENT_LOADED_ELEMENTS: 'SEGMENT_LOADED_ELEMENTS',
   DELETE_SELECTED_SEGMENTID: 'DELETE_SELECTED_SEGMENTID'
  } 